

class AndroidInterface{
    constructor() {
        if (window.AndroidBridge) {
            this.bridge = window.AndroidBridge;
        } else {
            console.warn("AndroidBridge is not available");
            this.bridge = undefined
        }
    }

    openNetworkSettings = () => {
        if(this.bridge !== undefined && this.bridge.openWifiSettings){
            this.bridge.openWifiSettings()
        }
    }

    openRemoteControl = () => {
        if(this.bridge !== undefined && this.bridge.openEsperSettings){
            this.bridge.openEsperSettings()
        }

    }
}

export const DeviceInterface = new AndroidInterface()

